<template>
  <div class='InputGift'>
    <div class="cont-icon-gift">
      <gift-icon size="30px"/>
    </div>
    <input v-model="codigo" placeholder="Insira um cupom" type="text">
    <div class="btn" @click="push">
      <label v-if="!load">aplicar</label>
      <component
      :is="Prefes.spinner.tipo"
      :color="'#FFFFFF'"
      :size="Prefes.spinner.tipo === 'EnbSyncLoader' ? '5px' : 20"
      style="z-index: 999"
      v-if="load"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import GiftIcon from '@/components/EnbPainel/Icons/GiftIcon'
import { loaders } from '@/components/Spinner'
export default {
  name: 'InputGift',
  components: { GiftIcon, ...loaders },
  data () {
    return {
      codigo: '',
      load: false
    }
  },
  computed: {
    ...mapGetters(['SelectedClientEdit', 'CheckoutItens01', 'cupom', 'Prefes'])
  },
  methods: {
    ...mapActions(['GetGiftStore']),
    push () {
      this.load = true
      this.GetGiftStore({ codigo: this.codigo, usuario: this.SelectedClientEdit.usuario, itens: this.CheckoutItens01, pedidoid: 0 })
        .then(() => this.load = false)
    }
  },
  created () {
    this.codigo = this.cupom.codigo
  }
}
</script>

<style scoped>
.InputGift {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  background-color: #EEEEEE;
  border: thin solid #CCCCCC;
  border-radius: 5px;
}

.btn {
  display: flex;
  width: 20%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFFFFF;
  background-color: #000000;
  border: thin solid #CCCCCC;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  font-size: 13px;
}

input {
  width: 80%;
  border: 0;
  font-size: 18px;
  padding: 2%;
}

input:focus {
  outline: none;
}

.cont-icon-gift {
  width: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
